<template>
  <v-row>
    <v-col v-if="!is_mobile_version" class="pt-0 pl-1 pr-1 pb-0">
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
          <v-row no-gutters>
            <v-col class="d-flex pa-0" style="flex-grow:1; justify-content:center">
              <div style="flex-wrap:nowrap; display:flex;">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                      v-on:click:date="dateRangeSelect"
                      hide-details
                    ></v-date-picker>

                    <v-divider></v-divider>

                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn text @click="menu_date_picker = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="menu_date_picker = false">Save</v-btn>
                    </v-card-actions> -->
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>
              
              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>

          <div style="flex-wrap:nowrap; display:flex;">
            <!-- <v-btn>
              <v-icon>mdi-export-variant</v-icon>&nbsp;Export
            </v-btn> -->
            <copy-shifts-restaurant-modal :shiftList="shiftListSearched" :intervalId="interval_selected_id" :dateRangeSelected="date_range_selected"></copy-shifts-restaurant-modal>
            <v-btn
                @click="moderatePeriodShifts"
                :loading="moderatePeriodLoading"
                class="blue lighten-3"
              >
              <v-icon>mdi-post</v-icon>&nbsp;Publish shifts&nbsp;[{{draftShifts}}]
            </v-btn>
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel calendar -->
        <v-card
          color="elevation-1"
          class="right-panel-restaurant-calendar"
          :height="scroll_panel_height - 31"
        >
          <!-- headers -->
          <v-card
            class="calendar-v-card-header"
            v-bind:class="{
              'v-card-day': interval_selected_id == INTERVAL_DAY,
              'v-card-week': interval_selected_id == INTERVAL_WEEK,
              'v-card-two-week': interval_selected_id == INTERVAL_TWO_WEEK,
              'v-card-month': interval_selected_id == INTERVAL_MONTH
            }"
            color="elevation-1"
          >
            <v-row
              no-gutters
            >
              <v-col
                v-for="item in period_list"
                :key="item.date"
                class="text-center"
              >
                {{ item.date | moment }}
              </v-col>
            </v-row>
          </v-card>
          <!--/ headers -->
          <!-- body -->
          <v-card
            class="calendar-v-card-body"
            v-bind:class="{
              'v-card-day': interval_selected_id == INTERVAL_DAY,
              'v-card-week': interval_selected_id == INTERVAL_WEEK,
              'v-card-two-week': interval_selected_id == INTERVAL_TWO_WEEK,
              'v-card-month': interval_selected_id == INTERVAL_MONTH
            }"
            color="elevation-0"
            v-for="(restaurant_item, i) in restaurantListSearched"
            :key="i"
            no-gutters
          >
            <v-card
              color="grey lighten-2"
            >
              <v-col>{{restaurant_item.name}}</v-col>
            </v-card>

            <v-row align="stretch">
              <v-col
                v-for="period_item in period_list"
                :key="period_item.date"
                class="text-center"
              >
                <v-hover
                  v-slot:default="{ hover:hover_col }"
                  open-delay="100"
                  style="height:100%;"
                >
                  <div><!-- v-hover require single child element -->
                      <new-shift-restaurant-modal :restaurantItem="restaurant_item" :periodDate="period_item.date"></new-shift-restaurant-modal>
                      
                      <v-tooltip bottom nudge-left="52" nudge-bottom="4" v-if="shift_to_copy && (hover_col || period_list_loading[period_item.date])">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            outlined
                            small
                            color="grey"
                            :loading="period_list_loading[period_item.date]"
                            @click="pasteShift(restaurant_item, period_item)"
                          >
                            <!-- v-if="shift_to_copy && (colHover || shift_to_copy.localLoading)" -->
                            <v-icon left>mdi-content-paste</v-icon>Paste
                          </v-btn>
                        </template>
                        <span>Hold the <span class="yellow--text">&quot;Shift&quot;</span> key to continue copying multiple times</span>
                      </v-tooltip>

                      <v-menu v-for="shift in period_item.restaurant_shifts[restaurant_item.id]" :key="shift.date">
                          <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                tile
                                small
                                block
                                class="shift-button_item"
                                v-bind:class="{
                                  'light-green lighten-3': shift.status == STATUS_PUBLICATED && !shift.status_assigned == STATUS_STALE,
                                  'yellow lighten-3': shift.status_assigned == STATUS_FREE, // STATUS_FREE wiil setup on server
                                  'red darken-3': shift.status_assigned == STATUS_STALE,
                                }"
                                :loading="shift.localLoading"
                              >
                                <div>
                                  <v-tooltip left nudge-left="50">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        ({{shift.start_time | formatTime}} - {{shift.finish_time | formatTime}})
                                        <v-icon style="font-size: 14px;" v-if="shift.status == STATUS_PUBLICATED">mdi-eye</v-icon>
                                        <v-icon style="font-size: 14px; color: red;" v-if="shift.status == STATUS_NEW">mdi-eye-off</v-icon>
                                        <v-icon style="font-size: 14px; color: gray;" v-if="shift.status == STATUS_DRAFT">mdi-eye-off</v-icon>
                                      </span>
                                    </template>
                                    <span v-if="shift.comment">{{shift.comment}}</span>
                                    <span v-if="!shift.comment">(empty)</span>
                                  </v-tooltip>
                                  <v-tooltip bottom nudge-left="52" nudge-bottom="10" v-if="shift.timesheet != null">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon style="font-size: 14px; color: #FF5722;">mdi-lock</v-icon>
                                      </span>
                                    </template>
                                    <span>Timesheet exists by this shift</span>
                                  </v-tooltip>
                                  <v-tooltip bottom nudge-left="0" nudge-bottom="0">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="getDriverPhone(shift) && on">
                                        <div>
                                          {{getDriverFullName(shift)}}
                                        </div>
                                      </span>
                                    </template>
                                    <span>
                                      Phone: {{getDriverPhone(shift)}}
                                    </span>
                                  </v-tooltip>
                                </div>
                              </v-btn>
                          </template>
                          <v-list>
                              <v-list-item @click="copyShift(shift)">
                                <v-list-item-title>Copy</v-list-item-title>
                              </v-list-item>
                              <edit-shift-restaurant-modal v-if="shift.timesheet == null" :shiftItem="shift"></edit-shift-restaurant-modal>
                              <v-list-item v-if="(shift.status == STATUS_NEW || shift.status == STATUS_DRAFT) && shift.status_assigned == STATUS_FREE && shift.timesheet == null" @click="removeShift(shift)">
                                <v-list-item-title>Remove</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_NEW)" v-if="shift.status == STATUS_DRAFT">
                                <v-list-item-title>Publish</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_DRAFT)" v-if="shift.status == STATUS_NEW && shift.timesheet == null">
                                <v-list-item-title>Unpublish</v-list-item-title>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                  </div>
                </v-hover>
              </v-col>
            </v-row>
          </v-card>
          <!--/ body -->
        </v-card>
        <!--/ right panel calendar -->
      </div>
      <!--/ body -->
      <!-- tool bar bottom -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: -5px;"
          tile
      >
        <v-app-bar
          fixed
          bottom
          height="36px"
          style="margin-left: 0px"
          color="elevation-1 tool-bar__totals-panel">
          <v-spacer></v-spacer>
          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.published}}</div>
              <div class="shift-total_label">Published Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.unpublished}}</div>
              <div class="shift-total_label">Unpublished Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.draft}}</div>
              <div class="shift-total_label">Draft Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.free}}</div>
              <div class="shift-total_label">Open Shifts</div>
            </v-btn>
          </div>
          <v-spacer></v-spacer>

          <div>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.total_shifts}}</div>
              <div class="shift-total_label">Total Shifts</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.filled_hours | formatHours}}</div>
              <div class="shift-total_label">Filled Hours</div>
            </v-btn>
            <!-- <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.estimated_cost | formatFloat}}</div>
              <div class="shift-total_label">Est. Cost</div>
            </v-btn>
            <v-btn tile small class="shift-button_item">
              <div class="shift-total_value">{{totals.expected_sales | formatFloat}}</div>
              <div class="shift-total_label">Expected Sales</div>
            </v-btn> -->
          </div>
        </v-app-bar>
      </v-card>
      <!--/ tool bar bottom -->
    </v-col>

    <!-- mobile version -->
    <v-col v-if="is_mobile_version">
      <!-- tool bar -->
      <v-card
        color="grey lighten-4"
        flat
        style="margin-bottom: 6px;"
        tile
      >
        <v-toolbar dense color="elevation-1 tool-bar__actions-panel header-btn-panel header-btn-panel-mobile" height="40">
          <v-row
            class="d-flex mb-auto"
            no-gutters
          >
            <div class="menu-date__picker-mobile">
              <v-btn @click="onPreviosRange">
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>

              <v-menu
                v-model="menu_date_picker"
                transition="scale-transition"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on">
                    {{dateRangeText(date_range_selected)}}
                  </v-btn>
                </template>

                <v-card max-width="346px">
                  <v-date-picker
                    v-model="date_range_selected"
                    scrollable
                    actions
                    full-width
                    first-day-of-week="1"
                    range
                    :title-date-format="dateRangeText"
                    v-on:click:date="dateRangeSelect"
                  ></v-date-picker>

                  <v-divider></v-divider>
                </v-card>
              </v-menu>

              <v-btn @click="onNextRange">
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>
            
            <div class="menu-interval-changer-mobile">
              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
              ></v-select>
            </div>

            <div class="menu-restaurant-changer-mobile">
              <v-select
                v-model="restaurant_id_mobile_selected"
                :items="restaurantListSearched"
                item-text="name"
                item-value="id"
                @change="onSelectRestaurantMobile"
                dense
                solo
                hide-details
              ></v-select>
            </div>
          </v-row>

          <v-row>
            <v-col>
              <copy-shifts-restaurant-modal :shiftList="shiftListSearched" :intervalId="interval_selected_id"></copy-shifts-restaurant-modal>
              <v-btn
                  @click="moderatePeriodShifts"
                  :loading="moderatePeriodLoading"
                  class="blue lighten-3 ml-1"
                >
                <v-icon>mdi-post</v-icon>&nbsp;Publish shifts&nbsp;[{{draftShifts}}]
              </v-btn>
            </v-col>
          </v-row>
          
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card>
      <!--/ tool bar -->
      <!-- body -->
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel calendar -->
        <v-card
          color="elevation-0"
          class="right-panel-calendar-mobile"
        >
          <v-card
            class="calendar-v-card-header"
            color="elevation-1"
          >
            <v-row
              v-for="period_item in period_list"
              :key="period_item.date"
            >
              <v-col class="text-center">
                <v-card
                  class="calendar-v-card-body"
                  color="elevation-0"
                >
                  <v-card
                    v-if="restaurant_item_mobile_selected"
                    color="grey lighten-2"
                  >
                    <!-- <v-col>{{restaurant_item_mobile_selected.name}}</v-col> -->
                    <v-col>{{ period_item.date | moment }}</v-col>
                  </v-card>
                  <v-row align="stretch">
                    <v-col class="text-center">
                      <new-shift-restaurant-modal :restaurantItem="restaurant_item_mobile_selected" :periodDate="period_item.date"></new-shift-restaurant-modal>
                      
                      <v-btn
                        outlined
                        small
                        color="grey"
                        v-if="shift_to_copy"
                        :loading="period_list_loading[period_item.date]"
                        @click="pasteShift(restaurant_item_mobile_selected, period_item)"
                      >
                        <v-icon left>mdi-content-paste</v-icon>Paste
                      </v-btn>

                      <v-menu v-for="shift in period_item.restaurant_shifts[restaurant_item_mobile_selected.id]" :key="shift.date">
                          <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                tile
                                small
                                block
                                class="shift-button_item shift-button_item-fix_height"
                                v-bind:class="{
                                  'light-green lighten-3': shift.status == STATUS_PUBLICATED && !shift.status_assigned == STATUS_STALE,
                                  'yellow lighten-3': shift.status_assigned == STATUS_FREE, // STATUS_FREE wiil setup on server
                                  'red darken-3': shift.status_assigned == STATUS_STALE,
                                }"
                                :loading="shift.localLoading"
                              >
                                <div>
                                  <v-tooltip left nudge-left="50">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        ({{shift.start_time | formatTime}} - {{shift.finish_time | formatTime}})
                                        <v-icon style="font-size: 14px;" v-if="shift.status == STATUS_PUBLICATED">mdi-eye</v-icon>
                                        <v-icon style="font-size: 14px; color: red;" v-if="shift.status == STATUS_NEW">mdi-eye-off</v-icon>
                                        <v-icon style="font-size: 14px; color: gray;" v-if="shift.status == STATUS_DRAFT">mdi-eye-off</v-icon>
                                      </span>
                                    </template>
                                    <span v-if="shift.comment">{{shift.comment}}</span>
                                    <span v-if="!shift.comment">(empty)</span>
                                  </v-tooltip>
                                  <v-tooltip bottom nudge-left="52" nudge-bottom="10" v-if="shift.timesheet != null">
                                    <template v-slot:activator="{ on }">
                                      <span v-on="on">
                                        <v-icon style="font-size: 14px; color: #FF5722;">mdi-lock</v-icon>
                                      </span>
                                    </template>
                                    <span>Timesheet exists by this shift</span>
                                  </v-tooltip>
                                  <div>
                                    {{getDriverFullName(shift)}}<span v-if="getDriverPhone(shift)">, phone: {{getDriverPhone(shift)}}</span>
                                  </div>
                                </div>
                              </v-btn>
                          </template>
                          <v-list>
                              <v-list-item @click="copyShift(shift)">
                                <v-list-item-title>Copy</v-list-item-title>
                              </v-list-item>
                              <edit-shift-restaurant-modal v-if="shift.timesheet == null" :shiftItem="shift"></edit-shift-restaurant-modal>
                              <v-list-item v-if="(shift.status == STATUS_NEW || shift.status == STATUS_DRAFT) && shift.status_assigned == STATUS_FREE && shift.timesheet == null" @click="removeShift(shift)">
                                <v-list-item-title>Remove</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_NEW)" v-if="shift.status == STATUS_DRAFT">
                                <v-list-item-title>Publish</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="changeShiftStatus(shift, STATUS_DRAFT)" v-if="shift.status == STATUS_NEW && shift.timesheet == null">
                                <v-list-item-title>Unpublish</v-list-item-title>
                              </v-list-item>
                          </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-card>
        <!--/ right panel calendar -->
      </div>
      <!--/ body -->
    </v-col>
    <!--/ mobile version -->
  </v-row>
</template>

<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { TYPE_AREA, TYPE_RESTAURANT } from '../../store/areas';
import { DATE_RANGE_HELPERS,
         STATUS_NEW, STATUS_PUBLICATED, STATUS_DRAFT,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH,
         STATUS_FREE, STATUS_STALE, STATUS_ASSIGNED
       } from '../../store/shifts';

export default {
  name: "Schedule",
  props: ['restaurantId'],
  data: () => ({
    // panels
    scroll_panel_height: window.innerHeight - 122,
    // const list for template
    TYPE_AREA: TYPE_AREA,
    TYPE_RESTAURANT: TYPE_RESTAURANT,
    STATUS_NEW: STATUS_NEW,
    STATUS_PUBLICATED: STATUS_PUBLICATED,
    STATUS_DRAFT: STATUS_DRAFT,
    STATUS_FREE: STATUS_FREE,
    STATUS_STALE: STATUS_STALE,
    STATUS_ASSIGNED: STATUS_ASSIGNED,
    INTERVAL_DAY: INTERVAL_DAY,
    INTERVAL_WEEK: INTERVAL_WEEK,
    INTERVAL_TWO_WEEK: INTERVAL_TWO_WEEK,
    INTERVAL_MONTH: INTERVAL_MONTH,
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      // { id: INTERVAL_MONTH, name: 'Month' },
    ],
    // ---
    date_range_selected: null,
    menu_date_picker: false,
    thisRestaurantId: null,
    localLoading: false,
    moderatePeriodLoading: false,
    restaurant_selected_index: 0,
    location_selected: void 0, // _guid
    interval_selected_id: INTERVAL_WEEK, // default week
    shift_to_copy: void 0,
    totals: {
      total_shifts: 0,
      filled_hours: 0,
      // estimated_cost: 0,
      // expected_sales: 0,
      published: 0,
      draft: 0,
      unpublished: 0,
      free: 0,
    },
    is_mobile_version: false,
    restaurant_id_mobile_selected: void 0,
    restaurant_item_mobile_selected: void 0,
    period_list_loading: {},
  }),
  computed: {
    ...mapGetters([
      'areas',
      'locations',
      'restaurants',
      'drivers'
    ]),
      //Other computed properties
    locations_list() {
      return this.locations;
      // return areas;
    },
    restaurant_list() {
      return this.restaurants;
    },
    driver_list() {
      return this.drivers;
    },
    restaurantListSearched() {
      let user = JSON.parse(localStorage.getItem("user"));

      let restaurants = [];
      _.each(user.restaurants, restaurant => {
        if (restaurant.status === 10) {
          restaurants.push({
            id: restaurant.id,
            name: restaurant.name,
            contact_name: restaurant.contact_name,
            email: user.email,
          });
        }
      });

      return restaurants;
    },
    shift_list() {
      return this.$store.getters.shifts;
    },
    shiftListSearched() {
      //-- apply shift_list filters:
      return this.shift_list;
    },
    area_list() {
      return this.$store.getters.areas;
    },
    period_list() {
      if (!this.$data.date_range_selected) {
        return;
      }

      let shift_list = this.shiftListSearched;
      // build period list
      let start_date_iterator = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      let i = 0;
      let period_list = [];
      while(start_date_iterator.format("YYYY-MM-DD") <= this.$data.date_range_selected[1]) {
        if (i == 31) {
          alert('Invalid date range: ' + this.$data.date_range_selected[0] + ' ~ ' + this.$data.date_range_selected[1]);
          break;
        }

        let period_date = start_date_iterator.format("YYYY-MM-DD");
        // cache shifts for better perfomance
        let restaurant_shifts = _.groupBy(
          _.filter(shift_list, p => {
            return p.period_date == period_date;
          }),
          'restaurant_id'
        );
        
        let period = {
          date: period_date,
          restaurant_shifts: restaurant_shifts,
        };

        period_list.push(period);

        if (!this.period_list_loading[period_date]) {
          this.period_list_loading[period_date] = false;
        }

        // incress date counter
        start_date_iterator.add(1, 'days');
        i++;
      }

      return period_list;
    },
    draftShifts() {
      let draft_shifts = _.filter(this.shiftListSearched, p => p.status == STATUS_DRAFT);
      return draft_shifts.length;
    },
    unpublishedShifts() {
      let unpublished_shifts = _.filter(this.shiftListSearched, p => p.status == STATUS_NEW);
      return unpublished_shifts.length;
    },
    freeShifts() {
      let free_shifts = _.filter(this.shiftListSearched, p => !p.driver_id);
      return free_shifts.length;
    }
  },
  watch: {
    shiftListSearched: function(shift_list_new) {
      if (shift_list_new.length == 0) {
        return; // exit
      }

      // calc totals
      this.$data.totals.total_shifts = shift_list_new.length;
      this.$data.totals.filled_hours = 0;
      // this.$data.totals.estimated_cost = 0;
      // this.$data.totals.expected_sales = 0;
      this.$data.totals.published = 0;
      this.$data.totals.draft = 0;
      this.$data.totals.unpublished = 0;
      this.$data.totals.free = 0;

      for (let j = 0; j < shift_list_new.length; j++) {
        this.$data.totals.filled_hours += this.getShiftHours(shift_list_new[j]);
        if (shift_list_new[j].status == STATUS_PUBLICATED) {
          // this.$data.totals.estimated_cost += +shift_list_new[j].cost_total;
          this.$data.totals.published += 1;
        } else if(shift_list_new[j].status == STATUS_DRAFT) {
          this.$data.totals.draft += 1;
        } else { // STATUS_NEW
          this.$data.totals.unpublished += 1;
        }
        if (shift_list_new[j].status_assigned == STATUS_FREE) { // !shift_list_new[j].driver_id
          this.$data.totals.free += 1;
        }
        // STATUS_PUBLICATED || STATUS_NEW
        // this.$data.totals.expected_sales += +shift_list_new[j].cost_total;
      }
    }
  },
  mounted() {
    // scroll panel height
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });

    this.$store.dispatch('fetchDrivers').then(() => {
      let current_date = moment();
      this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];

      this.dateRangeSelect();
    });

    if (!this.restaurant_item_mobile_selected && this.restaurantListSearched.length > 0) {
      this.restaurant_id_mobile_selected = this.restaurantListSearched[0].id;
      this.onSelectRestaurantMobile(this.restaurant_id_mobile_selected);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
    // detect mobile version
    let check = false;
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    this.is_mobile_version = check;
  },
  methods: {
    onResize() {
      this.scroll_panel_height = window.innerHeight - 122;
    },
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);
      
      // fetch shifts from server
      await this.$store.dispatch('fetchShifts', {
        period_date_from: this.$data.date_range_selected[0],
        period_date_to: this.$data.date_range_selected[1],
        with_timesheet: '1',
      });
    },
    getDriverFullName: function(shift) {
      if (shift.status_assigned == STATUS_FREE) { // !driver
        return 'Open shift';
      }

      let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
      if (!driver) {
        return 'Claimed';
      }

      return driver.full_name;
    },
    /** if it's shifts day, return also phone */
    getDriverPhone: function(shift) {
      if (moment(shift.period_date).format('YYYY-MM-DD') != moment().format('YYYY-MM-DD')) {
        return void 0;
      }

      let driver = _.find(this.driver_list, p => p.id == shift.driver_id);
      if (!driver) {
        return void 0;
      }

      return driver.phone;
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
        // let date_to_shift_start = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        // let date_to_shift_end = moment(this.$data.date_range_selected[1], "YYYY-MM-DD");
        // if (date_to_shift_start < current_day && current_day < date_to_shift_end) {
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
        // } else {
        //   this.$data.date_range_selected = [date_to_shift_start.format("YYYY-MM-DD"), null];
        // }
      }

      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onSelectRestaurantMobile: function(r_id) {
      this.restaurant_item_mobile_selected = _.find(this.restaurantListSearched, p => p.id == r_id);
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }
      
      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }
      
      // this.$data.date_range_selected
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    removeShift: function (shift) {
      if(!confirm('Remove shift ' + shift.period_date + '?')) {
        return; // exit
      }

      shift.localLoading = true;
      this.$store.dispatch('removeFreeShift', shift).then(() => {
      }).finally(() => {
        this.localLoading = false;
      });

      this.$data.shift_to_copy = void 0;
    },
    copyShift: function (shift) {
      this.$data.shift_to_copy = shift;
    },
    pasteShift: function (restaurant_item, period_item) {
      let me = this;
      me.$data.period_list_loading[period_item.date] = true;
      me.localLoading = true;

      // fix refresh :loading - use nextTick
      let tmp = me.$data.shift_to_copy;
      me.$data.shift_to_copy = void 0;
      Vue.nextTick(() => {
        me.$data.shift_to_copy = tmp;

        const newShift = {
          restaurant_id: restaurant_item.id,
          // driver_id: me.$data.shift_to_copy.driver_id,
          // status: STATUS_NEW,
          // status_assigned: STATUS_FREE,
          period_date: period_item.date, //!
          start_time: me.$data.shift_to_copy.start_time,
          finish_time: me.$data.shift_to_copy.finish_time,
          meal_time: 0,
          rest_time: 0,
          cost_per_hour: 0, //!
          cost_total: 0, //!
          comment: me.$data.shift_to_copy.comment,
          cost_bonus: 0, // me.$data.shift_to_copy.cost_bonus,
          const_fuel_bonus: 0, // me.$data.shift_to_copy.const_fuel_bonus,
          cost_extra_bonus: 0, // me.$data.shift_to_copy.cost_extra_bonus,
          // created_at: void 0,
          // updated_at: void 0,
        };
        
        // if "Shift" buutton pressed then can paste multiplie
        let continue_copy = !window.event.shiftKey;

        me.$store.dispatch('createNewFreeShift', newShift).then(() => {
          if (continue_copy) {
            me.$data.shift_to_copy = void 0;
          }
        }).finally(() => {
          me.period_list_loading[period_item.date] = false;
          me.localLoading = false;
        });
      });
    },
    changeShiftStatus: function(shift, status) {
      shift.status = status;
      this.localLoading = true;
      shift.localLoading = true;
      this.$store.dispatch('editFreeShift', shift).then(() => {
      }).finally(() => {
        this.localLoading = false;
        shift.localLoading = false;
      });

      this.$data.shift_to_copy = void 0;
    },
    moderatePeriodShifts: function() {
      if(!confirm('Publish '+ this.draftShifts +' shifts?')) {
        return; // exit
      }

      let draft_shifts = _.filter(this.shiftListSearched, p => p.status == STATUS_DRAFT);
      this.localLoading = true;
      this.moderatePeriodLoading = true;
      _.each(draft_shifts, shift => {
        shift.localLoading = true;
      });

      this.$store.dispatch('moderateFreeShifts', draft_shifts).then(() => {
      }).finally(() => {
        this.localLoading = false;
        this.moderatePeriodLoading = false;
        _.each(draft_shifts, shift => {
          shift.localLoading = false;
        });
      });

      this.$data.shift_to_copy = void 0;
    },
    // -- helpers:
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getShiftHours: function(shift_item) {
      //-- calc `shift_hours`
      let finish_time = moment(shift_item.finish_time, "HH:mm");
      let start_time = moment(shift_item.start_time, "HH:mm");
      if (!finish_time.isValid() || !start_time.isValid()) {
          return 0;
      }

      if (shift_item.finish_time < shift_item.start_time) {
        finish_time.add(1, 'days');
      }

      return ( (finish_time - start_time) / (60 * 1000) ) / 60;
    }
  },
  filters: {
      formatFloat: function (num) {
        return Number(num).toFixed(2);
      },
      formatHours: function (num) {
        return Number(num).toFixed(1);
      },
      moment: function (date) {
        return moment(date, "YYYY-MM-DD").format('MMM Do');
      },
      formatTime: function (time) {
        return moment(time, "HH:mm").format('HH:mm');
      },
    },
}
</script>

<style scoped>
  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .header-btn-panel-mobile {
    padding: 6px 0 6px;
  }

  .menu-date__picker-mobile {
    margin-bottom: 6px;
  }

  .right-panel-calendar-mobile {
    width: 100%;
  }
</style>

<style>
/* see styles in: src\components\Schedule\Schedule.vue */
.right-panel-restaurant-calendar {
    width: 100%;
    overflow-x:auto;
    padding-bottom:20px;
    margin-top: 47px;
    margin-bottom: 40px;
  }
</style>